// extracted by mini-css-extract-plugin
module.exports = {"container":"info_container__maChx","left":"info_left__1tLBp","right":"info_right__1LS_-","title":"info_title__Zmj0f","form":"info_form__2k9HG"};